export default {
	"id" : "KYC",
	"name" : "KYC",
	"page" : 2,
	"rules" : [
		{
			"conditions" : {
				"PoaContact-Id" : {
					"not": {
						"or": [
							{
								"is": ""
							},
							"undef"
						]						
					}
				}
			},
			"event": {
				"type": "setPoaReadonly"
			}
		},
		{
			"conditions" : {
			},
			"event" : {
				"type" : "updateSum"
			}
		},
		{
			"conditions" : {
				"Contact-FinServ__MaritalStatus__c" : {
					"or" : [
						{
							"is" : "Single"
						},
						{
							"is" : "Separated"
						},
						{
							"is" : "Divorced"
						},
						{
							"is" : "Widowed"
						}
					]
				}
			},
			"event" : {
				"type" : "remove",
				"params" : {
					"field" : [
						"Spouse-Politically_Exposed__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Contact-FinServ__MaritalStatus__c" : {
					"or" : [
						{
							"is" : "Married"
						},
						{
							"is" : "Common-Law"
						}
					]
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Spouse-Politically_Exposed__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-Tax_resident_other_than_Canada_or_US__c" : {
					"is" : "Yes"
				}
			},
			"event" : [
				{
					"type" : "require",
					"params" : {
						"field" : [
							"Account-If_YES_please_list_country_name__c",
						]
					}
				}
			]
		},
		{
			"conditions" : {
				"Account-Tax_resident_other_than_Canada_or_US__c" : {
					"is" : "No"
				}
			},
			"event" : [
				{
					"type" : "remove",
					"params" : {
						"field" : [
							"Account-If_YES_please_list_country_name__c",
							"Account-Other_Country_Taxpayer_ID_TIN__c"
						]
					}
				}
			]
		},
		{
			"conditions" : {
				"Account-US_tax_resident_or_citizen__c" : {
					"is" : "No"
				}
			},
			"event" : {
				"type" : "remove",
				"params" : {
					"field" : [
						"Account-US_Taxpayer_Identification_Number__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-US_tax_resident_or_citizen__c" : {
					"is" : "Yes"
				}
			},
			"event" : [
				{
					"type" : "require",
					"params" : {
						"field" : [
							"Account-US_Taxpayer_Identification_Number__c"
						]
					}
				}
			]
		},
		{
			"conditions" : {
				"Account-Are_you_using_borrowed_money_to_invest__c" : {
					"is" : "Yes"
				}
			},
			"event" : [
				{
					"type" : "require",
					"params" : {
						"field" : [
							"Account-LeveragedDisclosureAccounts"
						]
					}
				}
			]
		},
		{
			"conditions" : {
				"Account-Are_you_using_borrowed_money_to_invest__c" : {
					"is" : "No"
				}
			},
			"event" : [
				{
					"type" : "remove",
					"params" : {
						"field" : [
							"Account-LeveragedDisclosureAccounts"
						]
					}
				}
			]
		},
		{
			"conditions" : {
				"Account-Have_you_pledged_these_assets__c" : {
					"is" : "Yes"
				}
			},
			"event" : [
				{
					"type" : "require",
					"params" : {
						"field" : [
							"Account-CollateralAccounts"
						]
					}
				}
			]
		},
		{
			"conditions" : {
				"Account-Have_you_pledged_these_assets__c" : {
					"is" : "No"
				}
			},
			"event" : [
				{
					"type" : "remove",
					"params" : {
						"field" : [
							"Account-CollateralAccounts"
						]
					}
				}
			]
		},
		{
			"conditions" : {
				"Account-Insider__c" : {
					"is" : "Yes"
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : "Account-If_YES_to_Insider_list_company_name__c"
				}
			}
		},
		{
			"conditions" : {
				"not": {
					"Account-Insider__c" : {
						"is" : "Yes"
					}
				}
			},
			"event" : {
				"type" : "remove",
				"params" : {
					"field" : "Account-If_YES_to_Insider_list_company_name__c"
				}
			}
		},
		{
			"conditions" : {
			},
			"event" : {
				"type" : "updateSumFinancialAssetsBreakdown"
			}
		},
		{
			"conditions" : {
				"Account-Does_anyone_have_POA__c" : {
					"is" : "Yes"
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Account-Is_POA_Signing__c",
						"PoaContact-FirstName",
						"PoaContact-LastName",
						"PoaContact-Birthdate",
						"PoaContact-Email",
						"PoaContact-Phone",
						"PoaContact-FinServ__Occupation__c",
						"PoaContact-FinServ__CurrentEmployer__c",
						"PoaContact-Employer_Address__c",
						"PoaContact-Insider__c",
						"PoaAccount-BillingStreet",
						"PoaAccount-BillingCity",
						"PoaAccount-BillingState",
						"PoaAccount-BillingCountry",
						"PoaAccount-BillingPostalCode",
						"PoaContact-Politically_Exposed__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-Does_anyone_have_POA__c" : {
					"is" : "No"
				}
			},
			"event" : {
				"type" : "hidePoaSection",
				"params" : {
					"field" : [
						"Account-Is_POA_Signing__c",
						"PoaContact-FirstName",
						"PoaContact-LastName",
						"PoaContact-Birthdate",
						"PoaContact-Email",
						"PoaContact-Phone",
						"PoaContact-FinServ__Occupation__c",
						"PoaContact-FinServ__CurrentEmployer__c",
						"PoaContact-Employer_Address__c",
						"PoaContact-Insider__c",
						"PoaContact-If_YES_to_Insider_list_company_name__c",
						"PoaAccount-BillingStreet",
						"PoaAccount-BillingCity",
						"PoaAccount-BillingState",
						"PoaAccount-BillingCountry",
						"PoaAccount-BillingPostalCode",
						"PoaPoliticallyExposedPersonTitle",
						"PoaInsiderInformation",
						"PoaContact-Politically_Exposed__c",
						"PoaContact-Id"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-Does_anyone_have_POA__c" : {
					"is" : "Yes"
				}
			},
			"event" : {
				"type" : "showPoaSection",
				"params" : {
					"field" : [
						"Account-Is_POA_Signing__c",
						"PoaContact-FirstName",
						"PoaContact-LastName",
						"PoaContact-Birthdate",
						"PoaContact-Email",
						"PoaContact-Phone",
						"PoaContact-FinServ__Occupation__c",
						"PoaContact-FinServ__CurrentEmployer__c",
						"PoaContact-Employer_Address__c",
						"PoaContact-Insider__c",
						"PoaContact-If_YES_to_Insider_list_company_name__c",
						"PoaAccount-BillingStreet",
						"PoaAccount-BillingCity",
						"PoaAccount-BillingState",
						"PoaAccount-BillingCountry",
						"PoaAccount-BillingPostalCode",
						"PoaPoliticallyExposedPersonTitle",
						"PoaInsiderInformation",
						"PoaContact-Politically_Exposed__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"PoaContact-Insider__c" : {
					"is" : "Yes"
				},
				"Account-Does_anyone_have_POA__c" : {
					"is" : "Yes"
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : "PoaContact-If_YES_to_Insider_list_company_name__c"
				}
			}
		},
		{
			"conditions" : {
				"not": {
					"PoaContact-Insider__c" : {
						"is" : "Yes"
					}
				}
			},
			"event" : {
				"type" : "remove",
				"params" : {
					"field" : "PoaContact-If_YES_to_Insider_list_company_name__c"
				}
			}
		},
		{
			"conditions" : {
				"Account-Any_accounts_on_behalf_of_third_party__c" : {
					"is" : "Yes"
				}
			},
			"event" : {
				"type" : "require",
				"params" : {
					"field" : [
						"Account-Third_Party_Name__c",
						"Account-Third_Party_City__c",
						"Account-Third_Party_Country__c",
						"Account-Third_Party_State__c",
						"Account-Third_Party_Street__c",
						"Account-Third_Party_Postal_Code__c",
						"Account-Third_Party_Relationship_To_Client__c"
					]
				}
			}
		},
		{
			"conditions" : {
				"Account-Any_accounts_on_behalf_of_third_party__c" : {
					"is" : "No"
				}
			},
			"event" : {
				"type" : "remove",
				"params" : {
					"field" : [
						"Account-Third_Party_Name__c",
						"Account-Third_Party_City__c",
						"Account-Third_Party_Country__c",
						"Account-Third_Party_State__c",
						"Account-Third_Party_Street__c",
						"Account-Third_Party_Postal_Code__c",
						"Account-Third_Party_Date_of_Birth__c",
						"Account-Third_Party_Relationship_To_Client__c"
					]
				}
			}
		},
	],
	"uiSchema" : {
		"PoaContact-Id" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationFixedIncome-Asset_Percentage__c" : {
			"wrapperClassNames" : "col-xs-12 col-md-6",
			"ui:widget" : "updown"
		},
		"AssetAllocationEquity-Asset_Percentage__c" : {
			"wrapperClassNames" : "col-xs-12 col-md-6",
			"ui:widget" : "updown"
		},
		"AssetAllocationCash-Asset_Percentage__c" : {
			"wrapperClassNames" : "col-xs-12 col-md-6",
			"ui:widget" : "updown"
		},
		"AssetAllocationCash-Id" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationCash-FinServ__AssetsAndLiabilitiesType__c" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationCash-FinServ__AssetsAndLiabilitiesSource__c" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationCash-FinServ__PrimaryOwner__c" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationCash-RecordTypeId" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationCash-Name" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationEquity-Id" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationEquity-FinServ__AssetsAndLiabilitiesType__c" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationEquity-FinServ__AssetsAndLiabilitiesSource__c" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationEquity-FinServ__PrimaryOwner__c" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationEquity-RecordTypeId" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationEquity-Name" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationFixedIncome-Id" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationFixedIncome-FinServ__AssetsAndLiabilitiesType__c" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationFixedIncome-FinServ__AssetsAndLiabilitiesSource__c" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationFixedIncome-FinServ__PrimaryOwner__c" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationFixedIncome-RecordTypeId" : {
			"ui:widget" : "hidden"
		},
		"AssetAllocationFixedIncome-Name" : {
			"ui:widget" : "hidden"
		},
		"Contact-FinServ__MaritalStatus__c" : {
			"ui:widget" : "hidden"
		},
		"RegisteredMawerAsset-FinServ__Amount__c" : {
			"wrapperClassNames" : "col-xs-12 col-md-6",
			"ui:widget": "currencyNumberFormat"
		},
		"RegisteredMawerAsset-Id" : {
			"ui:widget" : "hidden"
		},
		"RegisteredMawerAsset-FinServ__AssetsAndLiabilitiesType__c" : {
			"ui:widget" : "hidden"
		},
		"RegisteredMawerAsset-FinServ__AssetsAndLiabilitiesSource__c" : {
			"ui:widget" : "hidden"
		},
		"RegisteredMawerAsset-FinServ__PrimaryOwner__c" : {
			"ui:widget" : "hidden"
		},
		"RegisteredMawerAsset-RecordTypeId" : {
			"ui:widget" : "hidden"
		},
		"RegisteredMawerAsset-Name" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredMawerAsset-FinServ__Amount__c" : {
			"wrapperClassNames" : "col-xs-12 col-md-6",
			"ui:widget": "currencyNumberFormat"
		},
		"NonRegisteredMawerAsset-Id" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredMawerAsset-FinServ__AssetsAndLiabilitiesType__c" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredMawerAsset-FinServ__AssetsAndLiabilitiesSource__c" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredMawerAsset-FinServ__PrimaryOwner__c" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredMawerAsset-RecordTypeId" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredMawerAsset-Name" : {
			"ui:widget" : "hidden"
		},
		"RegisteredNonMawerAsset-FinServ__Amount__c" : {
			"wrapperClassNames" : "col-xs-12 col-md-6",
			"ui:widget": "currencyNumberFormat"
		},
		"RegisteredNonMawerAsset-Id" : {
			"ui:widget" : "hidden"
		},
		"RegisteredNonMawerAsset-FinServ__AssetsAndLiabilitiesType__c" : {
			"ui:widget" : "hidden"
		},
		"RegisteredNonMawerAsset-FinServ__AssetsAndLiabilitiesSource__c" : {
			"ui:widget" : "hidden"
		},
		"RegisteredNonMawerAsset-FinServ__PrimaryOwner__c" : {
			"ui:widget" : "hidden"
		},
		"RegisteredNonMawerAsset-RecordTypeId" : {
			"ui:widget" : "hidden"
		},
		"RegisteredNonMawerAsset-Name" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredNonMawerAsset-FinServ__Amount__c" : {
			"wrapperClassNames" : "col-xs-12 col-md-6",
			"ui:widget": "currencyNumberFormat"
		},
		"NonRegisteredNonMawerAsset-Id" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredNonMawerAsset-FinServ__AssetsAndLiabilitiesType__c" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredNonMawerAsset-FinServ__AssetsAndLiabilitiesSource__c" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredNonMawerAsset-FinServ__PrimaryOwner__c" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredNonMawerAsset-RecordTypeId" : {
			"ui:widget" : "hidden"
		},
		"NonRegisteredNonMawerAsset-Name" : {
			"ui:widget" : "hidden"
		},
		"FixedAssets-Id" : {
			"ui:widget" : "hidden"
		},
		"FixedAssets-FinServ__AssetsAndLiabilitiesType__c" : {
			"ui:widget" : "hidden"
		},
		"FixedAssets-FinServ__PrimaryOwner__c" : {
			"ui:widget" : "hidden"
		},
		"FixedAssets-RecordTypeId" : {
			"ui:widget" : "hidden"
		},
		"FixedAssets-Name" : {
			"ui:widget" : "hidden"
		},
		"FixedAssets-FinServ__Amount__c" : {
			"ui:widget" : "currencyNumberFormat"		
		},
		"Liabilities-FinServ__Amount__c" : {
			"ui:widget" : "currencyNumberFormat"		
		},
		"Liabilities-Id" : {
			"ui:widget" : "hidden"
		},
		"Liabilities-FinServ__AssetsAndLiabilitiesType__c" : {
			"ui:widget" : "hidden"
		},
		"Liabilities-FinServ__PrimaryOwner__c" : {
			"ui:widget" : "hidden"
		},
		"Liabilities-RecordTypeId" : {
			"ui:widget" : "hidden"
		},
		"Liabilities-Name" : {
			"ui:widget" : "hidden"
		},
		"financialBreakdown" : {
			"header" : "Financial Breakdown",
			"classNames" : "full-column",
			"ui:widget" : "hidden"
		},
		"financialBreakdownText" : {
			"wrapperClassNames" : "col-xs-12 col-md-6"
		},
		"financialAssetsValueBreakdownText" : {
			"wrapperClassNames" : "col-xs-12 col-md-6"
		},
		"financialAssetsBreakdownSum" : {
			"ui:widget" : "hidden"
		},
		"legal" : {
			"header" : "Legal",
			"classNames" : "full-column",
			"ui:widget" : "hidden"
		},
		"insiderInformation" : {
			"wrapperClassNames" : "h5 col-xs-12 col-md-12"
		},
		"investmentKnowledgeDefinitions" : {
			"classNames" : "row",
			"wrapperTitle" : {
				"wrapperClassNames" : "h6 col-xs-12 col-md-12"
			},
			"veryLimited" : {
				"wrapperClassNames" : "col-xs-6 col-md-6"
			},
			"limited" : {
				"wrapperClassNames" : "col-xs-6 col-md-6"
			},
			"average" : {
				"wrapperClassNames" : "col-xs-6 col-md-6"
			},
			"aboveAverage" : {
				"wrapperClassNames" : "col-xs-6 col-md-6"
			},
			"expert" : {
				"wrapperClassNames" : "col-xs-6 col-md-6"
			}
		},
		"taxInformation" : {
			"wrapperClassNames" : "h5 col-xs-12 col-md-12"
		},
		"politicallyExposedPersonTitle" : {
			"wrapperClassNames" : "h5 col-xs-12 col-md-12"
		},
		"Account-Politically_Exposed__c" : {
			"ui:widget" : "radio"
		},
		"Spouse-Politically_Exposed__c" : {
			"ui:widget" : "radio"
		},
		"Account-US_tax_resident_or_citizen__c" : {
			"ui:widget" : "radio"
		},
		"Account-Tax_resident_other_than_Canada_or_US__c" : {
			"ui:widget" : "radio"
		},
		"Account-If_YES_please_list_country_name__c" : {
			"classNames" : "col-xs-2 col-md-6",
			// "$ref" : "#/definitions/countries",
			"ui:field" : "asyncTypeAhead",
			"asyncTypeahead" : {
				"id" : "Account-If_YES_please_list_country_name__c",
				"url" : "/api/value/country",
				"multiple" : false
			}
		},
		"Account-LeveragedDisclosureAccounts" : {
			"classNames" : "col-xs-2 col-md-6",
			"ui:field" : "asyncTypeAhead",
			"asyncTypeahead" : {
				"id" : "Account-LeveragedDisclosureAccounts",
				"url" : "/api/financialAccounts/",
				"multiple" : true
			},
			"ui:forceLabelDisplay": true
		},
		"Account-CollateralAccounts" : {
			"classNames" : "col-xs-2 col-md-6",
			"ui:field" : "asyncTypeAhead",
			"asyncTypeahead" : {
				"id" : "Account-CollateralAccounts",
				"url" : "/api/financialAccounts/",
				"multiple" : true
			},
			"ui:forceLabelDisplay": true
		},
		"Account-Other_Country_Taxpayer_ID_TIN__c" : {
			"ui:emptyValue": ""
		},
		"leveragedDisclosure" : {
			"wrapperClassNames" : "h5 col-xs-12 col-md-12"
		},
		"Account-Are_you_using_borrowed_money_to_invest__c" : {
			"ui:widget" : "radio"
		},
		"collateralAccount" : {
			"wrapperClassNames" : "h5 col-xs-12 col-md-12"
		},
		"Account-Have_you_pledged_these_assets__c" : {
			"ui:widget" : "radio"
		},
		"totalFinancialAssets" : {
			"ui:disabled" : true,
			"ui:widget": "currencyNumberFormat"
		},
		"totalNetWorth" : {
			"ui:disabled" : true,
			"ui:widget": "currencyNumberFormat"
		},
		"powerOfAttorney" : {
			"wrapperClassNames" : "h5 col-xs-12 col-md-12"
		},
		"Account-Does_anyone_have_POA__c" : {
			"ui:widget" : "radio"
		},
		"Account-Is_POA_Signing__c":{
			"ui:widget" : "radio"
		},
		"PoaContact-FirstName" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"PoaContact-LastName" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"PoaContact-Birthdate" : {
			"wrapperClassNames" : "col-xs-4 col-md-3",
			"ui:widget" : "materialDatePicker"
		},
		"PoaContact-Email" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"PoaContact-Phone" : {
			"wrapperClassNames" : "col-xs-4 col-md-4",
			"ui:widget": "phoneNumberInput"
		},
		"PoaAccount-BillingStreet" : {
			"wrapperClassNames" : "col-xs-8 col-md-8",
			"ui:widget" : "addressInput"
		},
		"PoaAccount-BillingCity" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"PoaAccount-BillingState" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"PoaAccount-BillingCountry" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"PoaAccount-BillingPostalCode" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		},
		"PoaContact-FinServ__Occupation__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4"
		},
		"PoaContact-FinServ__CurrentEmployer__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4"
		},
		"PoaContact-Employer_Address__c" : {
			"wrapperClassNames" : "col-xs-6 col-md-4"
		},
		"PoaInsiderInformation" : {
			"wrapperClassNames" : "h6 col-xs-12 col-md-12"
		},
		"PoaPoliticallyExposedPersonTitle" : {
			"wrapperClassNames" : "h6 col-xs-12 col-md-12"
		},
		"PoaContact-Politically_Exposed__c" : {
			"ui:widget" : "radio"
		},
		"PoaContact-Insider__c" : {
			"ui:widget" : "radio"
		},
		"thirdPartyInformation" : {
			"wrapperClassNames" : "h5 col-xs-12 col-md-12"
		},
		"Account-Any_accounts_on_behalf_of_third_party__c" : {
			"ui:widget" : "radio"
		},
		"Account-Insider__c" : {
			"ui:widget" : "radio"
		},
		"Account-Third_Party_Name__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},		
		"Account-Third_Party_City__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},		
		"Account-Third_Party_Country__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},		
		"Account-Third_Party_State__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},		
		"Account-Third_Party_Street__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3",
			"ui:widget" : "addressInput"
		},		
		"Account-Third_Party_Postal_Code__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},		
		"Account-Third_Party_Date_of_Birth__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3",
			"ui:widget" : "materialDatePicker"
		},		
		"Account-Third_Party_Relationship_To_Client__c" : {
			"wrapperClassNames" : "col-xs-2 col-md-3"
		},
		"AccountPlaceOfExecutionBanner" : {
			"header" : "Place of Document Execution",
			"classNames" : "full-column",
			"ui:widget" : "hidden"
		},
		"Account-Place_of_Document_Execution__c" : {
			"wrapperClassNames" : "col-xs-4 col-md-4"
		}
	},
	"schema" : {
		"required" : [
			"Account-Insider__c",
			"Account-Politically_Exposed__c",
			"Account-Tax_resident_other_than_Canada_or_US__c",
			"Account-US_tax_resident_or_citizen__c",
			"Account-Any_accounts_on_behalf_of_third_party__c",
			"Account-Does_anyone_have_POA__c",
			"Account-Place_of_Document_Execution__c",
			"AssetAllocationCash-Asset_Percentage__c",
			"AssetAllocationFixedIncome-Asset_Percentage__c",
			"AssetAllocationEquity-Asset_Percentage__c",
		],
		"title" : "Financial and Legal Information",
		"type" : "object",
		"root" : true,
		"properties" : {
			"Contact-FinServ__MaritalStatus__c" : {
				"type" : "string"
			},
			"financialAssetsValueBreakdownText" : {
				"title" : "Approximate value of all your financial assets (at Mawer and outside Mawer):",
				"type" : "null"
			},
			"financialBreakdownText" : {
				"title" : "Approximate breakdown of your financial assets (including any Mawer assets, sum must equal 100):",
				"type" : "null"
			},
			"RegisteredMawerAsset-FinServ__Amount__c" : {
				"title" : "Approximate value of your registered financial assets at Mawer:",
				"type" : ["number", "null"],
				"minimum" : 0
			},
			"AssetAllocationCash-Asset_Percentage__c" : {
				"title" : "Cash(%)",
				"type" : "integer",
				"minimum" : 0,
				"maximum" : 100
			},
			"NonRegisteredMawerAsset-FinServ__Amount__c" : {
				"title" : "Approximate value of your non-registered financial assets at Mawer:",
				"type" : ["number", "null"],
				"minimum" : 0
			},
			"AssetAllocationFixedIncome-Asset_Percentage__c" : {
				"title" : "Fixed Income(%)",
				"type" : "integer",
				"minimum" : 0,
				"maximum" : 100
			},
			"RegisteredNonMawerAsset-FinServ__Amount__c" : {
				"title" : "Approximate value of your registered financial assets outside Mawer:",
				"type" : ["number", "null"],
				"minimum" : 0
			},
			"AssetAllocationEquity-Asset_Percentage__c" : {
				"title" : "Equity(%)",
				"type" : "integer",
				"minimum" : 0,
				"maximum" : 100
			},
			"NonRegisteredNonMawerAsset-FinServ__Amount__c" : {
				"title" : "Approximate value of your non-registered financial assets outside Mawer:",
				"type" : ["number", "null"],
				"minimum" : 0
			},
			"financialAssetsBreakdownSum" : {
				"title" : "Assets Breakdown Total",
				"type" : "integer",
				"default" : 0,
				"minimum" : 100,
				"maximum" : 100
			},
			"AssetAllocationCash-Id" : {
				"type" : "string"
			},
			"AssetAllocationCash-FinServ__AssetsAndLiabilitiesType__c" : {
				"type" : "string"
			},
			"AssetAllocationCash-FinServ__AssetsAndLiabilitiesSource__c" : {
				"type" : "string"
			},
			"AssetAllocationCash-FinServ__PrimaryOwner__c" : {
				"type" : "string"
			},
			"AssetAllocationCash-RecordTypeId" : {
				"type" : "string"
			},
			"AssetAllocationCash-Name" : {
				"type" : "string"
			},
			"AssetAllocationEquity-Id" : {
				"type" : "string"
			},
			"AssetAllocationEquity-FinServ__AssetsAndLiabilitiesType__c" : {
				"type" : "string"
			},
			"AssetAllocationEquity-FinServ__AssetsAndLiabilitiesSource__c" : {
				"type" : "string"
			},
			"AssetAllocationEquity-FinServ__PrimaryOwner__c" : {
				"type" : "string"
			},
			"AssetAllocationEquity-RecordTypeId" : {
				"type" : "string"
			},
			"AssetAllocationEquity-Name" : {
				"type" : "string"
			},
			"AssetAllocationFixedIncome-Id" : {
				"type" : "string"
			},
			"AssetAllocationFixedIncome-FinServ__AssetsAndLiabilitiesType__c" : {
				"type" : "string"
			},
			"AssetAllocationFixedIncome-FinServ__AssetsAndLiabilitiesSource__c" : {
				"type" : "string"
			},
			"AssetAllocationFixedIncome-FinServ__PrimaryOwner__c" : {
				"type" : "string"
			},
			"AssetAllocationFixedIncome-RecordTypeId" : {
				"type" : "string"
			},
			"AssetAllocationFixedIncome-Name" : {
				"type" : "string"
			},
			"RegisteredMawerAsset-Id" : {
				"type" : "string"
			},
			"RegisteredMawerAsset-FinServ__AssetsAndLiabilitiesType__c" : {
				"type" : "string"
			},
			"RegisteredMawerAsset-FinServ__AssetsAndLiabilitiesSource__c" : {
				"type" : "string"
			},
			"RegisteredMawerAsset-FinServ__PrimaryOwner__c" : {
				"type" : "string"
			},
			"RegisteredMawerAsset-RecordTypeId" : {
				"type" : "string"
			},
			"RegisteredMawerAsset-Name" : {
				"type" : "string"
			},
			"NonRegisteredMawerAsset-Id" : {
				"type" : "string"
			},
			"NonRegisteredMawerAsset-FinServ__AssetsAndLiabilitiesType__c" : {
				"type" : "string"
			},
			"NonRegisteredMawerAsset-FinServ__AssetsAndLiabilitiesSource__c" : {
				"type" : "string"
			},
			"NonRegisteredMawerAsset-FinServ__PrimaryOwner__c" : {
				"type" : "string"
			},
			"NonRegisteredMawerAsset-RecordTypeId" : {
				"type" : "string"
			},
			"NonRegisteredMawerAsset-Name" : {
				"type" : "string"
			},
			"RegisteredNonMawerAsset-Id" : {
				"type" : "string"
			},
			"RegisteredNonMawerAsset-FinServ__AssetsAndLiabilitiesType__c" : {
				"type" : "string"
			},
			"RegisteredNonMawerAsset-FinServ__AssetsAndLiabilitiesSource__c" : {
				"type" : "string"
			},
			"RegisteredNonMawerAsset-FinServ__PrimaryOwner__c" : {
				"type" : "string"
			},
			"RegisteredNonMawerAsset-RecordTypeId" : {
				"type" : "string"
			},
			"RegisteredNonMawerAsset-Name" : {
				"type" : "string"
			},
			"NonRegisteredNonMawerAsset-Id" : {
				"type" : "string"
			},
			"NonRegisteredNonMawerAsset-FinServ__AssetsAndLiabilitiesType__c" : {
				"type" : "string"
			},
			"NonRegisteredNonMawerAsset-FinServ__AssetsAndLiabilitiesSource__c" : {
				"type" : "string"
			},
			"NonRegisteredNonMawerAsset-FinServ__PrimaryOwner__c" : {
				"type" : "string"
			},
			"NonRegisteredNonMawerAsset-RecordTypeId" : {
				"type" : "string"
			},
			"NonRegisteredNonMawerAsset-Name" : {
				"type" : "string"
			},
			"totalFinancialAssets" : {
				"title" : "Total Financial Assets",
				"type" : "string",
				"default" : 0,
				"minimum" : 0
			},
			"FixedAssets-FinServ__Amount__c" : {
				"title" : "What is the approximate value of your fixed assets ($ value of house , vehicles etc.)?",
				"type" : "number",
				"minimum" : 0
			},
			"FixedAssets-Id" : {
				"type" : "string"
			},
			"FixedAssets-FinServ__AssetsAndLiabilitiesType__c" : {
				"type" : "string"
			},
			"FixedAssets-FinServ__PrimaryOwner__c" : {
				"type" : "string"
			},
			"FixedAssets-RecordTypeId" : {
				"type" : "string"
			},
			"FixedAssets-Name" : {
				"type" : "string"
			},
			"Liabilities-FinServ__Amount__c" : {
				"title" : "What is the approximate value of your liabilities (mortgage, line of credit etc.)?",
				"type" : "number",
				"minimum" : 0
			},
			"Liabilities-Id" : {
				"type" : "string"
			},
			"Liabilities-FinServ__AssetsAndLiabilitiesType__c" : {
				"type" : "string"
			},
			"Liabilities-FinServ__PrimaryOwner__c" : {
				"type" : "string"
			},
			"Liabilities-RecordTypeId" : {
				"type" : "string"
			},
			"Liabilities-Name" : {
				"type" : "string"
			},
			"totalNetWorth" : {
				"title" : "Total Net Worth",
				"type" : "string",	// strange behavior if it's number, total value is 0, but won't update on UI
				"default" : 0
			},
			"Account-FinServ__InvestmentExperience__c" : {
				"title" : "Investment Knowledge",
				"type" : "string",
				"enum" : [
					"Very Limited",
					"Limited",
					"Average",
					"Above Average",
					"Expert"
				]
			},
			"investmentKnowledgeDefinitions" : {
				"type" : "object",
				"properties" : {
					"wrapperTitle" : {
						"title" : "Investment Knowledge Definitions",
						"type" : "null"
					},
					"veryLimited" : {
						"title" : "Very Limited: You have minimal investment knowledge and experience.",
						"type" : "null"
					},
					"limited" : {
						"title" : "Limited: You have limited investment knowledge or experience.",
						"type" : "null"
					},
					"average" : {
						"title" : "Average: You have been investing for a while and understand key investment concepts.",
						"type" : "null"
					},
					"aboveAverage" : {
						"title" : "Above Average: You are experienced in investing and have a good understanding of investments and financial markets.",
						"type" : "null"
					},
					"expert" : {
						"title" : "Expert: You are a very experienced investor with an expert understanding of investments and financial markets.",
						"type" : "null"
					}
				}
			},
			"legal" : {
				"type" : "null"
			},
			"insiderInformation" : {
				"title" : " ",
				"description" : "Insider Information",
				"type" : "null"
			},
			"Account-Insider__c" : {
				"title" : "Do you own, directly or indirectly, more than 10% of any class of public equity securities or are otherwise an \"insider\" as defined under applicable Canadian securities legislation? You undertake to notify us of any investment restrictions resulting from your designation as an \"insider\".",
				"$ref" : "#/definitions/yesNoCheckbox"
			},
			"Account-If_YES_to_Insider_list_company_name__c" : {
				"title" : "If yes to the above, please list the company and exchange symbol.",
				"type" : "string"
			},
			"taxInformation" : {
				"title" : " ",
				"description" : "Tax Information",
				"type" : "null"
			},
			"Account-Country_of_Residency__c" : {
				"title" : "Country of Residency",
				"$ref" : "#/definitions/countries",
				"default" : "Canada"
			},
			"Account-US_tax_resident_or_citizen__c" : {
				"title" : "Are you a tax resident or citizen of the United States?",
				"$ref" : "#/definitions/yesNoCheckbox",
				"default" : "No"
			},
			"Account-US_Taxpayer_Identification_Number__c" : {
				"title" : "U.S. Taxpayer Identification Number (TIN)",
				"type" : "string",
				"pattern": "^[0-9]{9}$"
			},
			"Account-Tax_resident_other_than_Canada_or_US__c" : {
				"title" : "Other Country",
				"$ref" : "#/definitions/yesNoCheckbox",
				"default" : "No"
			},
			"Account-If_YES_please_list_country_name__c" : {
				"title" : "Please provide other country name:",
				"type" : "string"
			},
			"Account-Other_Country_Taxpayer_ID_TIN__c" : {
				"title" : "Other Country Taxpayer Identification Number:",
				"type" : "string"
			},
			"politicallyExposedPersonTitle" : {
				"title" : " ",
				"description" : "Politically Exposed Person",
				"type" : "null"
			},
			"Account-Politically_Exposed__c" : {
				"title" : "Are you a foreign or domestic politically exposed person, a head of an international organization or a family member or close associate of one of these people?",
				"$ref" : "#/definitions/yesNoCheckbox",
				"default" : "No"
			},
			"Spouse-Politically_Exposed__c" : {
				"title" : "Is your spouse a foreign or domestic politically exposed person, a head of an international organization or a family member or close associate of one of these people?",
				"$ref" : "#/definitions/yesNoCheckbox",
				"default" : "No"
			},
			"leveragedDisclosure" : {
				"title" : " ",
				"description" : "Leveraged Disclosure",
				"type" : "null"
			},
			"Account-Are_you_using_borrowed_money_to_invest__c" : {
				"title" : "Are you using borrowed money to invest?",
				"$ref" : "#/definitions/yesNoCheckbox",
				"default" : "No"
			},
			"Account-LeveragedDisclosureAccounts" : {
				"title" : "If YES, please list the related financial account number(s):",
				"$ref" : "#/definitions/financialAccounts"
			},
			"collateralAccount" : {
				"title" : " ",
				"description" : "Collateral Account",
				"type" : "null"
			},
			"Account-Have_you_pledged_these_assets__c" : {
				"title" : "Have you pledged these assets?",
				"$ref" : "#/definitions/yesNoCheckbox",
				"default" : "No"
			},
			"Account-CollateralAccounts" : {
				"title" : "If YES, please list the related financial account number(s):",
				"$ref" : "#/definitions/financialAccounts"
			},
			"thirdPartyInformation" : {
				"title" : " ",
				"description" : "Third Party Information",
				"type" : "null"
			},
			"Account-Any_accounts_on_behalf_of_third_party__c" : {
				"title" : "Are any of the accounts to be used on behalf of a third party or does any other party have a financial interest in the account? (A third party is an individual or entity other than the account holder)",
				"$ref" : "#/definitions/yesNoCheckbox",
				"default" : "No"
			},
			"Account-Third_Party_Name__c" : {
				"title" : "Name",
				"type" : "string",
			},
			"Account-Third_Party_Date_of_Birth__c" : {
				"title" : "Date of Birth",
				"type" : "string",
				"format" : "date"
			},
			"Account-Third_Party_Street__c" : {
				"title" : "Street",
				"type" : "string",
			},
			"Account-Third_Party_City__c" : {
				"title" : "City",
				"type" : "string",
			},
			"Account-Third_Party_State__c" : {
				"title" : "Province/State",
				"type" : "string",
			},
			"Account-Third_Party_Country__c" : {
				"title" : "Country",
				"type" : "string",
			},
			"Account-Third_Party_Postal_Code__c" : {
				"title" : "Postal Code/Zip",
				"type" : "string",
			},
			"Account-Third_Party_Relationship_To_Client__c" : {
				"title" : "Relationship to Client",
				"$ref" : "#/definitions/relationships"
			},
			"powerOfAttorney" : {
				"title" : " ",
				"description" : "Power of Attorney",
				"type" : "null"
			},
			"Account-Does_anyone_have_POA__c" : {
				"title" : "Does any other person have Power of Attorney (POA) over any of these accounts? (If yes we will require an original or notarized POA document)",
				"$ref" : "#/definitions/yesNoCheckbox",
				"default" : "No"
			},			
			"Account-Is_POA_Signing__c" : {
				"title" : "Will POA be signing the documents?",
				"$ref" : "#/definitions/yesNoCheckbox",
				"default" : "Yes"
			},
			"PoaContact-Id" : {
				"type" : "string"
			},
			"PoaContact-FirstName" : {
				"title" : "First Name",
				"type" : "string"
			},
			"PoaContact-LastName" : {
				"title" : "Last Name",
				"type" : "string"
			},
			"PoaContact-Birthdate" : {
				"title" : "Date of Birth",
				"type" : "string",
				"format" : "date"
			},
			"PoaContact-Email" : {
				"title" : "Email",
				"type" : "string"
			},
			"PoaContact-Phone" : {
				"title" : "Phone",
				"type" : "string"
			},
			"PoaAccount-BillingStreet" : {
				"title" : "Address",
				"type" : "string"
			},
			"PoaAccount-BillingCity" : {
				"title" : "City",
				"type" : "string"
			},
			"PoaAccount-BillingState" : {
				"title" : "Province/State",
				"$ref" : "#/definitions/provinces"
			},
			"PoaAccount-BillingCountry" : {
				"title" : "Country",
				"$ref" : "#/definitions/countries"
			},
			"PoaAccount-BillingPostalCode" : {
				"title" : "Postal Code",
				"type" : "string"
			},
			"PoaContact-FinServ__Occupation__c" : {
				"root" : true,
				"title" : "Occupation",
				"type" : "string"
			},
			"PoaContact-FinServ__CurrentEmployer__c" : {
				"title" : "Employer Name",
				"type" : "string"
			},
			"PoaContact-Employer_Address__c" : {
				"title" : "Employer's City / Province or State",
				"type" : "string"
			},
			"PoaInsiderInformation" : {
				"title" : " ",
				"description" : "Insider Information",
				"type" : "null"
			},
			"PoaContact-Insider__c" : {
				"title" : "Do you own, directly or indirectly, more than 10% of any class of public equity securities or are otherwise an \"insider\" as defined under applicable Canadian securities legislation? You undertake to notify us of any investment restrictions resulting from your designation as an \"insider\".",
				"$ref" : "#/definitions/yesNoCheckbox"
			},
			"PoaContact-If_YES_to_Insider_list_company_name__c" : {
				"title" : "If yes to the above, please list the company and exchange symbol.",
				"type" : "string"
			},
			"PoaPoliticallyExposedPersonTitle" : {
				"title" : " ",
				"description" : "Politically Exposed Person",
				"type" : "null"
			},
			"PoaContact-Politically_Exposed__c" : {
				"title" : "Are you a foreign or domestic politically exposed person, a head of an international organization or a family member or close associate of one of these people?",
				"$ref" : "#/definitions/yesNoCheckbox"
			},
			"AccountPlaceOfExecutionBanner" : {
				"type" : "null"
			},
			"Account-Place_of_Document_Execution__c" : {
				"$ref" : "#/definitions/provinces"
			}
		},
		"definitions" : {
			"financialAccounts":{
				"type": "array", 
				"items": {
					"type": "string",
					 // "enum": []
				}
			},
			"yesNoCheckbox" : {
				"type" : "string",
				"oneOf" : [
					{
						"const" : "Yes",
						"title" : "Yes"
					},
					{
						"const" : "No",
						"title" : "No"
					}
				]
			},
			"boolCheckbox" : {
				"type" : "boolean",
				"oneOf" : [
					{
						"const" : true,
						"title" : "Yes"
					},
					{
						"const" : false,
						"title" : "No"
					}
				]
			},
			"provinces" : {
				"title" : "In which province or territory are you signing and executing your Mawer account documents?",
				"type" : "string",
				"enum" : [
					"Alberta",
					"British Columbia",
					"Manitoba",
					"New Brunswick",
					"Newfoundland and Labrador",
					"Northwest Territories",
					"Nova Scotia",
					"Nunavut",
					"Ontario",
					"Prince Edward Island",
					"Quebec",
					"Saskatchewan",
					"Yukon Territories"
				]
			},
			"clientRelationship" : {
				"title" : "Country",
				"type" : "string",
				"enum" : [
					"Accountant",
					"Adminstrator",
					"Advisor",
					"Authorized Individual",
					"Authorized Signer",
					"Beneficial Owner",
					"Billing Contact",
					"Board Member",
					"Consultant",
					"Custodian",
					"Investment Committee Member",
					"Joint Owner",
					"Original Depositor",
					"Power of Attorney",
					"Primary Contact",
					"Primary Owner",
					"Record-Keeper",
					"Reporting Contact",
					"Trustee"
				]
			},
			"relationships" : {
				"title" : "Relationship",
				"type" : "string",
				"enum" : [
					"Custodian",
					"Consultant",
					"Planner",
					"Advisor",
					"Extended Family",
					"Trustee",
					"Common-law Partner",
					"Spouse",
					"Ex-Spouse",
					"Power of Attorney",
					"Sibling",
					"Child",
					"Grandchild",
					"Grandparent",
					"Accountant",
					"Lawyer",
					"Parent",
					"Executive Assistant",
					"Trusted Contact Person",
					"Advocate"
				]
			},
			"countries" : {
				"title" : "Country",
				"type" : "string",
				"enum" : [
					"United States of America",
					"Canada",
					"Afghanistan",
					"Aland Islands",
					"Albania",
					"Algeria",
					"Andorra",
					"Angola",
					"Anguilla",
					"Antarctica",
					"Antigua and Barbuda",
					"Argentina",
					"Armenia",
					"Aruba",
					"Australia",
					"Austria",
					"Azerbaijan",
					"Bahamas",
					"Bahrain",
					"Bangladesh",
					"Barbados",
					"Belarus",
					"Belgium",
					"Belize",
					"Benin",
					"Bermuda",
					"Bhutan",
					"Bolivia, Plurinational State of",
					"Bonaire, Sint Eustatius and Saba",
					"Bosnia and Herzegovina",
					"Botswana",
					"Bouvet Island",
					"Brazil",
					"British Indian Ocean Territory",
					"Brunei Darussalam",
					"Bulgaria",
					"Burkina Faso",
					"Burundi",
					"Cambodia",
					"Cameroon",
					"Cape Verde",
					"Cayman Islands",
					"Central African Republic",
					"Chad",
					"Chile",
					"China",
					"Christmas Island",
					"Cocos (Keeling) Islands",
					"Colombia",
					"Comoros",
					"Congo",
					"Congo, the Democratic Republic of the",
					"Cook Islands",
					"Costa Rica",
					"Cote d’Ivoire",
					"Croatia",
					"Cuba",
					"Curaçao",
					"Cyprus",
					"Czech Republic",
					"Denmark",
					"Djibouti",
					"Dominica",
					"Dominican Republic",
					"Ecuador",
					"Egypt",
					"El Salvador",
					"Equatorial Guinea",
					"Eritrea",
					"Estonia",
					"Ethiopia",
					"Falkland Islands (Malvinas)",
					"Faroe Islands",
					"Fiji",
					"Finland",
					"France",
					"French Guiana",
					"French Polynesia",
					"French Southern Territories",
					"Gabon",
					"Gambia",
					"Georgia",
					"Germany",
					"Ghana",
					"Gibraltar",
					"Greece",
					"Greenland",
					"Grenada",
					"Guadeloupe",
					"Guatemala",
					"Guernsey",
					"Guinea",
					"Guinea-Bissau",
					"Guyana",
					"Haiti",
					"Heard Island and McDonald Islands",
					"Holy See (Vatican City State)",
					"Honduras",
					"Hungary",
					"Iceland",
					"India",
					"Indonesia",
					"Iran, Islamic Republic of",
					"Iraq",
					"Ireland",
					"Isle of Man",
					"Israel",
					"Italy",
					"Jamaica",
					"Japan",
					"Jersey",
					"Jordan",
					"Kazakhstan",
					"Kenya",
					"Kiribati",
					"Korea, Democratic People’s Republic of",
					"Korea, Republic of",
					"Kuwait",
					"Kyrgyzstan",
					"Lao People’s Democratic Republic",
					"Latvia",
					"Lebanon",
					"Lesotho",
					"Liberia",
					"Libyan Arab Jamahiriya",
					"Liechtenstein",
					"Lithuania",
					"Luxembourg",
					"Macao",
					"Macedonia, the former Yugoslav Republic of",
					"Madagascar",
					"Malawi",
					"Malaysia",
					"Maldives",
					"Mali",
					"Malta",
					"Martinique",
					"Mauritania",
					"Mauritius",
					"Mayotte",
					"Mexico",
					"Moldova, Republic of",
					"Monaco",
					"Mongolia",
					"Montenegro",
					"Montserrat",
					"Morocco",
					"Mozambique",
					"Myanmar",
					"Namibia",
					"Nauru",
					"Nepal",
					"Netherlands",
					"New Caledonia",
					"New Zealand",
					"Nicaragua",
					"Niger",
					"Nigeria",
					"Niue",
					"Norfolk Island",
					"Norway",
					"Oman",
					"Pakistan",
					"Palestine",
					"Panama",
					"Papua New Guinea",
					"Paraguay",
					"Peru",
					"Philippines",
					"Pitcairn",
					"Poland",
					"Portugal",
					"Qatar",
					"Reunion",
					"Romania",
					"Russian Federation",
					"Rwanda",
					"Saint Barthélemy",
					"Saint Helena, Ascension and Tristan da Cunha",
					"Saint Kitts and Nevis",
					"Saint Lucia",
					"Saint Martin (French part)",
					"Saint Pierre and Miquelon",
					"Saint Vincent and the Grenadines",
					"Samoa",
					"San Marino",
					"Sao Tome and Principe",
					"Saudi Arabia",
					"Senegal",
					"Serbia",
					"Seychelles",
					"Sierra Leone",
					"Singapore",
					"Sint Maarten (Dutch part)",
					"Slovakia",
					"Slovenia",
					"Solomon Islands",
					"Somalia",
					"South Africa",
					"South Georgia and the South Sandwich Islands",
					"South Sudan",
					"Spain",
					"Sri Lanka",
					"Sudan",
					"Suriname",
					"Svalbard and Jan Mayen",
					"Swaziland",
					"Sweden",
					"Switzerland",
					"Syrian Arab Republic",
					"Taiwan",
					"Tajikistan",
					"Tanzania, United Republic of",
					"Thailand",
					"Timor-Leste",
					"Togo",
					"Tokelau",
					"Tonga",
					"Trinidad and Tobago",
					"Tunisia",
					"Turkey",
					"Turkmenistan",
					"Turks and Caicos Islands",
					"Tuvalu",
					"Uganda",
					"Ukraine",
					"United Arab Emirates",
					"United Kingdom",
					"Uruguay",
					"Uzbekistan",
					"Vanuatu",
					"Venezuela, Bolivarian Republic of",
					"Vietnam",
					"Virgin Islands, British",
					"Wallis and Futuna",
					"Western Sahara",
					"Yemen",
					"Zambia",
					"Zimbabwe"
				]
			},
			"provinces" : {
				"title" : "Province/State",
				"type" : "string",
				"anyOf" : [
					{
						"type" : "string",
						"title" : "Alberta",
						"enum" : [
							"Alberta"
						]
					},
					{
						"type" : "string",
						"title" : "British Columbia",
						"enum" : [
							"British Columbia"
						]
					},
					{
						"type" : "string",
						"title" : "Manitoba",
						"enum" : [
							"Manitoba"
						]
					},
					{
						"type" : "string",
						"title" : "New Brunswick",
						"enum" : [
							"New Brunswick"
						]
					},
					{
						"type" : "string",
						"title" : "Newfoundland and Labrador",
						"enum" : [
							"Newfoundland and Labrador"
						]
					},
					{
						"type" : "string",
						"title" : "Northwest Territories",
						"enum" : [
							"Northwest Territories"
						]
					},
					{
						"type" : "string",
						"title" : "Nova Scotia",
						"enum" : [
							"Nova Scotia"
						]
					},
					{
						"type" : "string",
						"title" : "Nunavut",
						"enum" : [
							"Nunavut"
						]
					},
					{
						"type" : "string",
						"title" : "Ontario",
						"enum" : [
							"Ontario"
						]
					},
					{
						"type" : "string",
						"title" : "Prince Edward Island",
						"enum" : [
							"Prince Edward Island"
						]
					},
					{
						"type" : "string",
						"title" : "Quebec",
						"enum" : [
							"Quebec"
						]
					},
					{
						"type" : "string",
						"title" : "Saskatchewan",
						"enum" : [
							"Saskatchewan"
						]
					},
					{
						"type" : "string",
						"title" : "Yukon Territories",
						"enum" : [
							"Yukon Territories"
						]
					},
					{
						"type" : "string",
						"title" : "Alabama",
						"enum" : [
							"Alabama"
						]
					},
					{
						"type" : "string",
						"title" : "Alaska",
						"enum" : [
							"Alaska"
						]
					},
					{
						"type" : "string",
						"title" : "American Samoa",
						"enum" : [
							"American Samoa"
						]
					},
					{
						"type" : "string",
						"title" : "Arizona",
						"enum" : [
							"Arizona"
						]
					},
					{
						"type" : "string",
						"title" : "Arkansas",
						"enum" : [
							"Arkansas"
						]
					},
					{
						"type" : "string",
						"title" : "California",
						"enum" : [
							"California"
						]
					},
					{
						"type" : "string",
						"title" : "Colorado",
						"enum" : [
							"Colorado"
						]
					},
					{
						"type" : "string",
						"title" : "Connecticut",
						"enum" : [
							"Connecticut"
						]
					},
					{
						"type" : "string",
						"title" : "Delaware",
						"enum" : [
							"Delaware"
						]
					},
					{
						"type" : "string",
						"title" : "District Of Columbia",
						"enum" : [
							"District Of Columbia"
						]
					},
					{
						"type" : "string",
						"title" : "Federated States Of Micronesia",
						"enum" : [
							"Federated States Of Micronesia"
						]
					},
					{
						"type" : "string",
						"title" : "Florida",
						"enum" : [
							"Florida"
						]
					},
					{
						"type" : "string",
						"title" : "Georgia",
						"enum" : [
							"Georgia"
						]
					},
					{
						"type" : "string",
						"title" : "Guam",
						"enum" : [
							"Guam"
						]
					},
					{
						"type" : "string",
						"title" : "Hawaii",
						"enum" : [
							"Hawaii"
						]
					},
					{
						"type" : "string",
						"title" : "Idaho",
						"enum" : [
							"Idaho"
						]
					},
					{
						"type" : "string",
						"title" : "Illinois",
						"enum" : [
							"Illinois"
						]
					},
					{
						"type" : "string",
						"title" : "Indiana",
						"enum" : [
							"Indiana"
						]
					},
					{
						"type" : "string",
						"title" : "Iowa",
						"enum" : [
							"Iowa"
						]
					},
					{
						"type" : "string",
						"title" : "Kansas",
						"enum" : [
							"Kansas"
						]
					},
					{
						"type" : "string",
						"title" : "Kentucky",
						"enum" : [
							"Kentucky"
						]
					},
					{
						"type" : "string",
						"title" : "Louisiana",
						"enum" : [
							"Louisiana"
						]
					},
					{
						"type" : "string",
						"title" : "Maine",
						"enum" : [
							"Maine"
						]
					},
					{
						"type" : "string",
						"title" : "Marshall Islands",
						"enum" : [
							"Marshall Islands"
						]
					},
					{
						"type" : "string",
						"title" : "Maryland",
						"enum" : [
							"Maryland"
						]
					},
					{
						"type" : "string",
						"title" : "Massachusetts",
						"enum" : [
							"Massachusetts"
						]
					},
					{
						"type" : "string",
						"title" : "Michigan",
						"enum" : [
							"Michigan"
						]
					},
					{
						"type" : "string",
						"title" : "Minnesota",
						"enum" : [
							"Minnesota"
						]
					},
					{
						"type" : "string",
						"title" : "Mississippi",
						"enum" : [
							"Mississippi"
						]
					},
					{
						"type" : "string",
						"title" : "Missouri",
						"enum" : [
							"Missouri"
						]
					},
					{
						"type" : "string",
						"title" : "Montana",
						"enum" : [
							"Montana"
						]
					},
					{
						"type" : "string",
						"title" : "Nebraska",
						"enum" : [
							"Nebraska"
						]
					},
					{
						"type" : "string",
						"title" : "Nevada",
						"enum" : [
							"Nevada"
						]
					},
					{
						"type" : "string",
						"title" : "New Hampshire",
						"enum" : [
							"New Hampshire"
						]
					},
					{
						"type" : "string",
						"title" : "New Jersey",
						"enum" : [
							"New Jersey"
						]
					},
					{
						"type" : "string",
						"title" : "New Mexico",
						"enum" : [
							"New Mexico"
						]
					},
					{
						"type" : "string",
						"title" : "New York",
						"enum" : [
							"New York"
						]
					},
					{
						"type" : "string",
						"title" : "North Carolina",
						"enum" : [
							"North Carolina"
						]
					},
					{
						"type" : "string",
						"title" : "North Dakota",
						"enum" : [
							"North Dakota"
						]
					},
					{
						"type" : "string",
						"title" : "Northern Mariana Islands",
						"enum" : [
							"Northern Mariana Islands"
						]
					},
					{
						"type" : "string",
						"title" : "Ohio",
						"enum" : [
							"Ohio"
						]
					},
					{
						"type" : "string",
						"title" : "Oklahoma",
						"enum" : [
							"Oklahoma"
						]
					},
					{
						"type" : "string",
						"title" : "Oregon",
						"enum" : [
							"Oregon"
						]
					},
					{
						"type" : "string",
						"title" : "Palau",
						"enum" : [
							"Palau"
						]
					},
					{
						"type" : "string",
						"title" : "Pennsylvania",
						"enum" : [
							"Pennsylvania"
						]
					},
					{
						"type" : "string",
						"title" : "Puerto Rico",
						"enum" : [
							"Puerto Rico"
						]
					},
					{
						"type" : "string",
						"title" : "Rhode Island",
						"enum" : [
							"Rhode Island"
						]
					},
					{
						"type" : "string",
						"title" : "South Carolina",
						"enum" : [
							"South Carolina"
						]
					},
					{
						"type" : "string",
						"title" : "South Dakota",
						"enum" : [
							"South Dakota"
						]
					},
					{
						"type" : "string",
						"title" : "Tennessee",
						"enum" : [
							"Tennessee"
						]
					},
					{
						"type" : "string",
						"title" : "Texas",
						"enum" : [
							"Texas"
						]
					},
					{
						"type" : "string",
						"title" : "Utah",
						"enum" : [
							"Utah"
						]
					},
					{
						"type" : "string",
						"title" : "Vermont",
						"enum" : [
							"Vermont"
						]
					},
					{
						"type" : "string",
						"title" : "Virgin Islands",
						"enum" : [
							"Virgin Islands"
						]
					},
					{
						"type" : "string",
						"title" : "Virginia",
						"enum" : [
							"Virginia"
						]
					},
					{
						"type" : "string",
						"title" : "Washington",
						"enum" : [
							"Washington"
						]
					},
					{
						"type" : "string",
						"title" : "West Virginia",
						"enum" : [
							"West Virginia"
						]
					},
					{
						"type" : "string",
						"title" : "Wisconsin",
						"enum" : [
							"Wisconsin"
						]
					},
					{
						"type" : "string",
						"title" : "Wyoming",
						"enum" : [
							"Wyoming"
						]
					}
				]
			}
		}
	}
}